var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8333 0.666687H6.16668C2.66668 0.666687 0.333344 3.00002 0.333344 6.50002V13.5C0.333344 17 2.66668 19.3334 6.16668 19.3334H17.8333C21.3333 19.3334 23.6667 17 23.6667 13.5V6.50002C23.6667 3.00002 21.3333 0.666687 17.8333 0.666687ZM14.205 11.2017L11.3233 12.9284C10.1567 13.6284 9.19998 13.0917 9.19998 11.7267V8.2617C9.19998 6.8967 10.1567 6.36003 11.3233 7.06003L14.205 8.78668C15.3134 9.46334 15.3134 10.5367 14.205 11.2017Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.102cac6115ce1a5de4661ae95ac32bb3.svg";
export { ForwardRef as ReactComponent };